import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

//Services for FF Rates Screen

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getApproverDelegateData = async () => {
    // InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "DELEGATE_APPROVER_DROPDOWN";
    inputObj["Input"] = "";
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  export const postAssignDelegateData = async (input) => {
     InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "DELEGATE_ROLE_ASSIGN";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  }